export default "__VITE_ASSET__Q7NitiGr__"